export const accessoriesListSelector = (state) => state.accessories.accessoriesList;
export const accessoriesStatusSelector = (state) => state.accessories.status;
export const apiFailedSelector = (state) => state.accessories.apiFailed;